import './ComparisonList.css';const comparisonList = "_comparisonList_1ggos_1";
const comparisonList__body = "_comparisonList__body_1ggos_37";
const comparisonList__item = "_comparisonList__item_1ggos_97";
const comparisonList__track = "_comparisonList__track_1ggos_141";
const styles = {
  comparisonList,
  "comparisonList--sticky": "_comparisonList--sticky_1ggos_16",
  comparisonList__body,
  "comparisonList__body--sticky": "_comparisonList__body--sticky_1ggos_52",
  comparisonList__item,
  comparisonList__track
};
export {
  comparisonList,
  comparisonList__body,
  comparisonList__item,
  comparisonList__track,
  styles as default
};
